import { colors } from '@atlaskit/theme';
import { messages } from './messages';

const GREY_LIGHT = {
	id: 'grey-subtler',
	value: colors.N300,
	label: messages.colorPickerLightGrey,
};

const GREY = {
	id: 'gray-subtle',
	value: colors.N500,
	label: messages.colorPickerGrey,
};

const GREY_DARK = {
	id: 'gray.bolder',
	value: colors.N700,
	label: messages.colorPickerGrey,
};

const BLUE_LIGHT = {
	id: 'blue-subtler',
	value: colors.B75,
	label: messages.colorPickerLightBlue,
};

const BLUE = {
	id: 'blue-subtle',
	value: colors.B200,
	label: messages.colorPickerBlue,
};

const BLUE_DARK = {
	id: 'blue.bolder',
	value: colors.B400,
	label: messages.colorPickerDarkBlue,
};

const TEAL_LIGHT = {
	id: 'teal-light',
	value: colors.T75,
	label: messages.colorPickerLightTeal,
};

const TEAL = {
	id: 'teal-subtle',
	value: colors.T200,
	label: messages.colorPickerTeal,
};

const TEAL_DARK = {
	id: 'teal-bolder',
	value: colors.T400,
	label: messages.colorPickerDarkTeal,
};

const GREEN_LIGHT = {
	id: 'green-light',
	value: colors.G75,
	label: messages.colorPickerLightGreen,
};

const GREEN = {
	id: 'green-subtle',
	value: colors.G200,
	label: messages.colorPickerGreen,
};

const GREEN_DARK = {
	id: 'green-bolder',
	value: colors.G400,
	label: messages.colorPickerDarkGreen,
};

const YELLOW_LIGHT = {
	id: 'yellow-subtler',
	value: colors.Y75,
	label: messages.colorPickerLightYellow,
};

const YELLOW = {
	id: 'yellow-subtle',
	value: colors.Y200,
	label: messages.colorPickerYellow,
};

const YELLOW_DARK = {
	id: 'yellow-bolder',
	value: colors.Y400,
	label: messages.colorPickerDarkYellow,
};

const RED_LIGHT = {
	id: 'red-subtler',
	value: colors.R75,
	label: messages.colorPickerLightRed,
};

const RED = {
	id: 'reb-subtle',
	value: colors.R200,
	label: messages.colorPickerRed,
};

const RED_DARK = {
	id: 'red-bolder',
	value: colors.R400,
	label: messages.colorPickerDarkRed,
};

const PURPLE_LIGHT = {
	id: 'purple-subtler',
	value: colors.P75,
	label: messages.colorPickerLightPurple,
};

export const PURPLE = {
	id: 'purple-subtle',
	value: colors.P200,
	label: messages.colorPickerPurple,
};

const PURPLE_DARK = {
	id: 'purple-bolder',
	value: colors.P400,
	label: messages.colorPickerDarkPurple,
};

export const colorPalette = [
	GREY_LIGHT,
	BLUE_LIGHT,
	TEAL_LIGHT,
	GREEN_LIGHT,
	YELLOW_LIGHT,
	RED_LIGHT,
	PURPLE_LIGHT,
	GREY,
	BLUE,
	TEAL,
	GREEN,
	YELLOW,
	RED,
	PURPLE,
	GREY_DARK,
	BLUE_DARK,
	TEAL_DARK,
	GREEN_DARK,
	YELLOW_DARK,
	RED_DARK,
	PURPLE_DARK,
];
